export const environment = {
  production: true,
  API_SERVER_URL: 'https://www.firstlife.com.tw/OnlineInsuranceProduct',
  WEBINSURANCE_API_URL: 'https://www.firstlife.com.tw/WebInsurance/',
  FIRST_LIFE_INSURANCE_SERVER_URL: 'https://www.firstlife.com.tw/FirstOnlineInsuranceWeb',
  KEYCLOAK_URL: 'https://www.firstlife.com.tw',
  FIRST_LIFE_INSURANCE_INDEX_URL: 'https://www.firstlife.com.tw/FirstOnlineInsuranceWeb/',
  FUNDRICH_INDEX_URL: 'https://www.firstlife.com.tw/FirstOnlineInsuranceWeb/fundrich/index.html',
};
